import { render } from "./ShowcaseCard.vue?vue&type=template&id=f161e6be&ts=true"
import script from "./ShowcaseCard.vue?vue&type=script&lang=ts"
export * from "./ShowcaseCard.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__